import * as PropTypes from "prop-types";
import {connect} from 'react-redux';
import {formValueSelector, reduxForm} from 'redux-form';
import {ff, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormBody, FormActions} = form;
import CustomCheckboxField from "../../components/CustomCheckboxField";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro úpravu parametrů objednávky.
 */
class ParametryObjednavkyForm extends Component<WithTranslation> {

    static formName = 'ParametryObjednavkyForm';

    static propTypes = {
        ukonyList: PropTypes.array.isRequired, // pole existujících úkonů
    };

    static validate = (values, props) => {
        const {ukonyList, t} = props;
        const errors = {};
        if (!values.pocetVyhotoveni) {
            errors.pocetVyhotoveni = t('validation.field_required');
        }
        if (values.razitkovat && !values.razCiselnaRada) {
            errors.razCiselnaRada = t('validation.stamping_number_series_required');
        }
        ukonyList.forEach(ukon => {
            if (ukon.povinne && values.ukony && (!values.ukony[ukon.id] || values.ukony[ukon.id] === null)) {
                errors.ukony = errors.ukony || [];
                errors.ukony[ukon.id] = t('validation.task_required');
            }
        });
        return errors;
    };

    render() {
        const {onClose, submitting, handleSubmit, razitkovat, ukonyList, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.Number int label={t('order.number_of_copies')} name="pocetVyhotoveni" disabled={submitting}/>
                <CustomCheckboxField label={t('order.stamp')} name="razitkovat" disabled={submitting}/>
                <ff.String label={t('order.number_series')} name="razCiselnaRada" maxLength={20} disabled={submitting || !razitkovat}/>
                <ff.Textarea label={t('note')} name="poznamka" disabled={submitting} />
                <ff.Textarea label={t('order.internal_note')} name="poznamkaInterni" disabled={submitting} />
                {ukonyList.map((ukon, index) => {
                    return <ff.ObjectSuggest
                        key={index}
                        label={ukon.nazevUkon}
                        name={`ukony[${ukon.id}]`}
                        dropdown={true}
                        removable={false}
                        items={ukon.polozky}
                        itemValueAttrName="popisUkon"
                        required={ukon.povinne}
                    />
                })}
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

const selector = formValueSelector(ParametryObjednavkyForm.formName);

const mapStateToProps = state => ({
    razitkovat: selector(state, "razitkovat"),
});

export default withTranslation()(connect(mapStateToProps)(reduxForm({
    form: ParametryObjednavkyForm.formName,
    validate: ParametryObjednavkyForm.validate,
})(ParametryObjednavkyForm)));
